module.exports = __webpack_public_path__ + "img/TL.95cb60f6.svg";